import React from 'react';
import styled from 'styled-components';
import { SectionWrapper,ContentContainer } from './SectionWrapper';

const WelcomeSection = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};

  return (
    <SectionWrapper>
      <ContentContainer>
        <h2>{church.welcome_title || 'Welcome to Our Church'}</h2>
        <p>
          {church.welcome_text ||
            'We are honored to have you here. Our church is a place of love, worship, and transformation. Join us as we grow together in Christ.'}
        </p>
      </ContentContainer>
    </SectionWrapper>
  );
};

export default WelcomeSection;
